/* eslint-disable no-param-reassign */
import { getConfig } from '../../../config';

let api;

const checkConfig = () => {
  if (!api) api = getConfig('api');
};

const defaultQuery = {
  "page": 1,
  "limit": 10,
  "sort": [],
  "q": null,
  "country": null
};

/**
 * Get the tendero with the given id
 * @param {string} id id of the tendero to get
 */
export const getTendero = (id) => {
  checkConfig();
  return api.get(`/users/${id}?all=true`);
};

export const getTenderos = (query) => {
  query.type = 'referrer';
  checkConfig();
  return api.get('/users', query);
};

export const postTenderos = (data) => {
  data.type = 'referrer';
  checkConfig();
  return api.post('/users', data);
};

export const updateTendero = (id, data) => {
  checkConfig();
  delete data.metadata.status;
  delete data.metadata.lapsed;
  delete data.metadata.reactivated;
  return api.put(`/users/${id}`, data);
};

/**
 * Delete the tendero with the given id
 * @param {string} id id of the tendero to delete
 */
export const deleteTendero = (id) => {
  checkConfig();
  return api.delete(`/users/${id}`);
};

  /**
 * Soft delete the tendero with the given id
 * @param {string} id id of the tendero to delete
 */
export const softDeleteTendero = (id) => {
  checkConfig();
  return api.put(`/users/status/${id}`, { status: 'deleted' });
};

export const getBuyers = (query) => {
  checkConfig();
  // TODO this should list customers and referrers but not agents
  return api.get('/users', { ...defaultQuery, ...query });
};

export const getUserMeta = () => {
  checkConfig();
  return api.get(`/users/meta-data`);
};

/**
 * Export users
 */
export const exportUsers = (data) => {
  checkConfig();
  return api.get(`/users/exportUsers`, data);
};

  /**
 * Update status of the tendero with the given id
 * @param {string} id id of the tendero to delete
 */
   export const updateStatusTendero = (id, status) => {
    checkConfig();
    return api.put(`/users/status/${id}`, { status });
  };

  export const getPointsTendero = (id, query) => {
    checkConfig();
    return api.get(`/pointsManage/${id}`, query);
  };

  export const addPointsTendero = (query) => {
    checkConfig();
    return api.post(`/pointsManage`, query);
  };

